import { render, staticRenderFns } from "./CreateQuestions.vue?vue&type=template&id=5d41156b&"
import script from "./CreateQuestions.vue?vue&type=script&lang=js&"
export * from "./CreateQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports